export function splitArray(array, tamanhoDoGrupo) {
  const resultado = [];
  for (let i = 0; i < array.length; i += tamanhoDoGrupo) {
    resultado.push(array.slice(i, i + tamanhoDoGrupo));
  }
  return resultado;
}
